import React from "react";
import { Link } from "react-router-dom";
import { Button, CircularProgress, TextField, Select, FormControl, InputLabel, MenuItem } from "@material-ui/core";

import { PAGE_ROUTES, LOADING_STATE } from "../../utils/stateTypes";
import SEO_DATA from "../../utils/seoData";
import SeoHead from "../general/SeoHead";

const styles = {
  input: {
    maxWidth: 600,
    margin: "5px 0",
    textAlign: "left",
  },
  button: {
    width: "100%",
    maxWidth: 600,
    height: 54,
    marginTop: 10,
  },
  backButton: {
    margin: "40px 0",
  },
};

const sendCancel = async (email, reason, setSendState) => {
  setSendState(LOADING_STATE.LOADING);
  const response = await fetch("/api/Store/CancelSubscription", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      email,
      reason,
    }),
  });
  if (response.ok) {
    setSendState(LOADING_STATE.LOADED);
  }
  else {
    setSendState(LOADING_STATE.ERROR);
  }
};


const CancelSubscription = () => {
  const [email, setEmail] = React.useState("");
  const [reason, setReason] = React.useState("");
  const [sendState, setSendState] = React.useState(LOADING_STATE.NOT_LOADING);

  return (
    <main>
      <SeoHead
        {...SEO_DATA[PAGE_ROUTES.CANCEL_SUBSCRIPTION]}
        path={PAGE_ROUTES.CANCEL_SUBSCRIPTION}
      />

      <header className={"page-header standard-width"}>
        <h1 className={"section-head"}>Subscription cancellation</h1>
      </header>
 
      <section className={"thank-you-section standard-width"}>
        <p className={"thank-you-text"}>
          Enter you email address and click submit to cancel your subscription.
        </p>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            sendCancel(email, reason, setSendState);
          }}
        >
          <TextField
            label={"Email"}
            variant={"filled"}
            color={"secondary"}
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            style={styles.input}
            type={"email"}
            fullWidth
            required
          />
          <FormControl
            variant={"filled"}
            color={"secondary"}
            style={styles.input}
            fullWidth
          >
            <InputLabel>Reason</InputLabel>
            <Select
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              MenuProps={{
                disableScrollLock: true,
              }}
              color={"secondary"}
            >
              <MenuItem
                value={"Financial constraints"}
                style={styles.menuItem}
              >
                Financial constraints
              </MenuItem>
              <MenuItem
                value={"Food preference and taste"}
                style={styles.menuItem}
              >
                Food preference and taste
              </MenuItem>
              <MenuItem
                value={"Not using the subscription"}
                style={styles.menuItem}
              >
                Not using the subscription
              </MenuItem>
              <MenuItem
                value={"Dietary restrictions or health issues"}
                style={styles.menuItem}
              >
                Dietary restrictions or health issues
              </MenuItem>
              <MenuItem
                value={"Other"}
                style={styles.menuItem}
              >
                Other
              </MenuItem>
            </Select>
          </FormControl>
          <Button
            variant={"contained"}
            color={"primary"}
            style={styles.button}
            type={"submit"}
            disabled={sendState !== LOADING_STATE.NOT_LOADING}
          >
            {(sendState === LOADING_STATE.LOADING) ? (
              <CircularProgress
                size={25}
                color={"secondary"}
              />
            ) : "Submit"}
          </Button>

          {
            (sendState === LOADING_STATE.LOADED) && (
              <p className={"subcancel-success"}>
                Your subscription has been successfully cancelled. Hope to see you back soon!
              </p>
            )
          }

          {
            (sendState === LOADING_STATE.ERROR) && (
              <p className={"subcancel-error"}>
                An error occurred while cancelling your subscription. Please contact ashthedietitian@gmail.com for assistance.
              </p>
            )
          }
        </form>
        <Link to={PAGE_ROUTES.HOME}>
          <Button
            variant={"contained"}
            color={"secondary"}
            style={styles.backButton}
          >
            Back to Home
          </Button>
        </Link>
      </section>
    </main>
  );
};

export default CancelSubscription;

